import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'

export const Layout: FC<LayoutProps> = ({ children, className }): ReactNode => {
    return (
        <main id='main-content' className={cn('mx-auto w-full max-w-[1440px] flex-1 px-4 pb-20 pt-6 sm:px-6 lg:pt-8', className)}>
            {children}
        </main>
    )
}
